"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileSelectionFilter_1 = require("./store/schema/FileSelectionFilter");
exports.FileSelectionFilter = FileSelectionFilter_1.default;
var owa_bundling_1 = require("owa-bundling");
var fileProvidersLoaded_1 = require("./actions/fileProvidersLoaded");
exports.fileProvidersLoaded = fileProvidersLoaded_1.fileProvidersLoaded;
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "FilePicker" */ './lazyIndex');
});
// Exported actions
exports.lazyRemoveFileProvider = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.removeFileProvider; });
// Exported services
exports.lazyGetAllFileProvidersService = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getAllFileProvidersService; });
exports.lazyRemoveFileProviderService = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.removeFileProviderService; });
// Exported utils
exports.lazyCreateFileProvidersViewState = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.createFileProvidersViewState; });
exports.lazyGetAllFileProviders = new owa_bundling_1.LazyImport(lazyModule, function (m) { return m.getAllFileProviders; });
// The store
var store_1 = require("./store/store");
exports.store = store_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/data/owa-fileprovider-store/lib/index.js
// module id = 597
// module chunks = 2 3 40 106 107